/**
 * ImpersonationBanner (DEV-555)
 *
 * Fixed banner shown at the top of the viewport when an admin is
 * impersonating another user. Shows who they're viewing as and
 * provides a one-click "Return to Admin" button.
 *
 * English only — system admin utility.
 */

import React from 'react';
import { useAuth } from '../../auth/AuthContext';
import styles from './ImpersonationBanner.module.css';

export default function ImpersonationBanner() {
  const { isImpersonating, user, impersonatorDisplayName, endImpersonate } = useAuth();

  if (!isImpersonating || !user) return null;

  const handleEndImpersonate = async () => {
    try {
      await endImpersonate();
      // Force a full page reload to re-fetch all data for the admin user
      window.location.href = '/';
    } catch (err: any) {
      console.error('[ImpersonationBanner] Failed to end impersonation:', err);
    }
  };

  return (
    <div className={styles.banner}>
      <span className={styles.text}>
        Viewing as <strong>{user.displayName || user.email}</strong>
        {impersonatorDisplayName && (
          <span className={styles.adminLabel}> (logged in as {impersonatorDisplayName})</span>
        )}
      </span>
      <button className={styles.returnBtn} onClick={handleEndImpersonate}>
        Return to Admin
      </button>
    </div>
  );
}
